// e.g. "AUD - Australian Dollar"
export function getMarketLabel(market) {
  if (!market) return ''

  return `${market.Currency} - ${market.CurrencyName}`
}

// Picks the market whose time zones include the browser's, falling back to the default market.
export function detectMarket(markets = [], defaultMarket = 'AU', timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
  return markets.find((market) => market.Enabled && market.TimeZones?.includes(timeZone))?.Code || defaultMarket
}
